module.exports = __webpack_public_path__ + "static/media/rain-icon.38c13799.svg";